import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.js';

up.compiler('#mainNavigation .dropdown-toggle', async (element: HTMLElement, data) => {
    const dropdown = new bootstrap.Dropdown(element, {
        popperConfig(defaultBsPopperConfig) {
            defaultBsPopperConfig.modifiers[0].enabled = true;
            return defaultBsPopperConfig;
        }
    })    
});